export const AREA_TO_SECTION_ID = {
  'thumbnail': 'thumbnail',
  'top-left': 'image-overlay-top-left',
  'top-right': 'image-overlay-top-right',
  'bottom-left': 'image-overlay-bottom-left',
  'bottom-right': 'image-overlay-bottom-right',
  'avatar': 'avatar',
  'title': 'card-title',
  'content': 'card-content',
  'footer-left': 'card-footer-left',
  'footer-right': 'card-footer-right',
  // 'price-details': 'price-details',
  'schedule-tour': 'schedule-tour',
  'features': 'features',
  'excerpt': 'excerpt',
  'location': 'location'
};

export const AREA_LABELS = {
  'thumbnail': 'Thumbnail',
  'top-left': 'Top Left',
  'top-right': 'Top Right',
  'bottom-left': 'Bottom Left',
  'bottom-right': 'Bottom Right',
  'avatar': 'Avatar',
  'title': 'Title Area',
  'content': 'Content Area',
  'footer-left': 'Footer Left',
  'footer-right': 'Footer Right',
  // 'price-details': 'Price Details',
  'schedule-tour': 'Schedule Tour',
  'features': 'Features',
  'excerpt': 'Excerpt',
  'location': 'Location'
};